//
//
//
//
//
//
//
//
//
//
//
//
//

import { defineComponent, computed } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'HeaderBannerCard',
  props: {
    banner: { type: Object, required: false, default: null }
  },
  setup(props) {
    const img = computed(() => props.banner?.image || '');
    const alt = computed(() => props.banner?.title || 'Banner');
    const link = computed(() => ({
      url: props.banner?.link || '#',
      target: '_self',
      rel: 'nofollow sponsored noopener'
    }));

    return { img, alt, link };
  }
});
